// extracted by mini-css-extract-plugin
module.exports = {"rating":"bk","numberOfStars":"ck"};